import HundredBricksAPIError from '../../../HundredBricksAPIError';
class QuotationError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('QuotationError', ...args);
    }
}
export default QuotationError;
